// Días hábiles (lun-vie) sobre 'YYYY-MM-DD'. Espejo de utils/businessDays.js (backend).
// Usado por el stepper del SmartRescheduleModal para que las flechas salten el fin de semana.
export function isWeekend(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dow = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return dow === 0 || dow === 6;
}
export function addDays(dateStr, n) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt.toISOString().slice(0, 10);
}
export function bumpBusinessDay(dateStr, dir) {
  const step = dir >= 0 ? 1 : -1;
  let cur = addDays(dateStr, step);
  while (isWeekend(cur)) cur = addDays(cur, step);
  return cur;
}
